export type IncidentChatState = {
  callerMessagePreview: string | null;
  isCallerSendingImage: boolean;
  isSendingImage: boolean;
};

export const INITIAL_INCIDENT_CHAT_STATE: IncidentChatState = {
  callerMessagePreview: null,
  isCallerSendingImage: false,
  isSendingImage: false,
};

export type IncidentChatAction =
  | { type: 'caller-text-preview-received'; messagePreview: string | null }
  | { type: 'caller-image-preview-received'; isSendingImage: boolean }
  | { type: 'send-image-started' }
  | { type: 'send-image-finished' };

export function incidentChatReducer(state: IncidentChatState, action: IncidentChatAction): IncidentChatState {
  switch (action.type) {
    case 'caller-text-preview-received':
      return { ...state, callerMessagePreview: action.messagePreview };
    case 'caller-image-preview-received':
      return { ...state, isCallerSendingImage: action.isSendingImage };
    case 'send-image-started':
      return { ...state, isSendingImage: true };
    case 'send-image-finished':
      return { ...state, isSendingImage: false };
  }
}
